<template>
  <gj-modal size="1200_auto" class="reply-off-site-mailbox-add-mail" :visible.sync="modalVisible">
    <template #header>{{ draftsId ? '编辑邮件' : '新建邮件' }}</template>
    <template #content>
      <div class="add-mail">
        <div class="add-mail-left">
          <el-form ref="form" :model="form" size="small" label-width="80px" :rules="rules">
            <div>
              <el-row>
                <el-col :span="15">
                  <el-form-item label="邮件主题" prop="subject">
                    <el-input v-model="form.subject" placeholder="请输入邮件主题"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="发件邮箱" prop="emailId">
                    <el-select
                      v-model="form.emailId"
                      placeholder="请选择发件邮箱"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in userEmailList"
                        :key="item.emailId"
                        :label="item.name"
                        :value="item.emailId"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="15">
                  <el-form-item label="收件人">
                    <el-input
                      :disabled="!!emailAddressExcel.length"
                      v-model="form.emailAddress"
                      placeholder="请输入收件人"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="邮件模版">
                    <el-cascader
                      style="width: 100%"
                      v-model="form.templateId"
                      :options="emailTemplateList"
                      @change="emailgHandleChange"
                      :props="{
                        children: 'marketMailTemplateVOList',
                        value: 'id',
                        label: 'name',
                        emitPath: false,
                      }"
                    ></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" style="margin-bottom: 10px">
                <el-col :span="12">
                  <el-form-item label="" style="margin: 0">
                    <gj-upload
                      text="上传收件人"
                      :fileList="emailAddressExcel"
                      class="upload-btn email-addressExcel"
                      :template-url="'crm/outTicketItem/outTicketItemExcel'"
                      container-type="mailReply"
                      :specialUpload="true"
                      @uploadAfter="importRelateProduct"
                      @update:fileList="updateFileList"
                      :limit="1"

                    >
                      <!-- <template #tip>
                      <span>只能上传xls/xlsx文件</span>
                    </template> -->
                    </gj-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12" style="padding-top: 5px" v-if="emailAddressExcel.length">
                  <span @click="checkUser" style="cursor: pointer">查看收件人名单 ></span>
                </el-col>
              </el-row>
              <div style="padding-left: 80px;">
                <gj-wang-editor
                  ref="gjWangEditor"
                  v-model="form.content"
                  :maxLength="4000"
                  height="279"
                >
                </gj-wang-editor>
              </div>
            </div>
            <div class="footer-op">
              <div class="file-list">
                <div
                  @click="downloadFile(item.attId)"
                  v-for="item in attachments"
                  :key="item.attId"
                  class="file-item"
                >
                  <i class="el-icon-document"></i>
                  <span class="file-name">{{ item.name }}</span>
                  <i class="el-icon-delete gj-ml10" @click.stop="removeFile(item)"></i>
                </div>
              </div>
              <div class="flex justify-between align-center">
                <div class="flex">
                  <gj-upload
                    class="enclosure-upload"
                    container-type="listingRelateProduct"
                    :specialUpload="true"
                    :fileList="attachments"
                    uploadBtnType="text"
                    text="上传附件"
                    @uploadAfter="importEnclosure"
                    @update:fileList="updateFileListEnclosure"
                    :limit="10"
                    :validFileSize="100"
                    :on-exceed="onExceed"
                  >
                  </gj-upload>
                  <el-checkbox v-model="form.isDateSend" class="el-checkbox-my">定时发送</el-checkbox>
                  <span v-if="form.isDateSend" style="padding-left: 30px" class="my-slelct-send">
                    <el-select v-model="form.sendDateType" placeholder="请选择">
                      <el-option
                        v-for="item in dateOptionList"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <el-date-picker
                      class="no-left-boeder"
                      v-model="form.date"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                      style="line-height: 38px"
                    >
                    </el-date-picker>
                    <el-time-select
                      class="no-left-boeder"
                      v-model="form.time"
                      :picker-options="{
                        start: '00:00',
                        step: '01:00',
                        end: '23:00',
                      }"
                      placeholder="选择时间"
                      style="line-height: 38px"
                    >
                    </el-time-select>
                  </span>
                </div>
                <div>
                  <el-button size="small" @click="save" :loading="loadingSave">保存草稿</el-button>
                  <el-button type="primary" size="small" :disabled="remainingMail<=0" @click="confirm" :loading="loadingConfirm"
                    >发送</el-button
                  >
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="add-mail-right">
          <div style="color: rgba(51, 51, 51, 1); font-size: 12px">邮件剩余可用量</div>
          <p class="remaining-mail">
            <span :class="{'color-1000':remainingMail>0 && remainingMail <= 1000,'color-0':remainingMail==0}">{{ remainingMail }}</span>
            <span v-if="remainingMail<=1000" class="to-buy" @click="$router.push('/setting/erp-package')"> 去充值 > </span>
          </p>
          <div class="be-careful">
            <div>收件人导入注意事项；</div>
            <div style="margin-top: 10px">
              ① 仅支持导入格式为<font color="red">XLS</font>的文件；
            </div>
            <div>② 模板标题不可更改；</div>
            <div>③ 模板表头红色字段为必填项，非红色字段为选填项；</div>
            <div>④ 重复邮箱数据，以第一条为准。</div>
          </div>
          <div class="const-item-box">
            <span class="title">变量</span>
            <span
              @click="insertVariable(item.id)"
              class="const-item"
              v-for="(item, index) in variableOptions"
              :key="index"
            >
              {{ item.label }}
            </span>
          </div>
        </div>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import { formRuleMixin, modalMixIn, responseMixin } from './../../../../../../minxins';
import GjWangEditor from '@/components/wang-editor/gj-wang-editor';
import * as xlsx from 'xlsx';
import { getAllTemplateList, outTicketItemDraftSave } from '@/api/crm.js';
import AppUserTable from './user-table';
import GjCascaderSelect from '../components/cascader-select';
import { outEmailList, outTicketItemSend, outTicketItemDraftsDetail } from '@/api/crm.js';
import { getRemainingMail, downloadAttFile } from '@/api/common';
export default {
  name: 'add-mail-modal',
  mixins: [modalMixIn, formRuleMixin, responseMixin],
  components: { GjWangEditor, GjCascaderSelect },
  props: {
    emailAddress: {
      type: String,
      default: '',
    },
    draftsId: {
      default: '',
    },
  },
  data() {
    return {
      loadingConfirm: false,
      loadingSave: false,
      emailAddressExcel: [],
      attachments: [],
      remainingMail: '-',
      variableOptions: [
        {
          id: '{买家姓名}',
          label: '买家姓名',
          preview: '{name}',
        },
        {
          id: '{买家邮箱}',
          label: '买家邮箱',
          preview: '{email}',
        },
        {
          id: '{扩展字段1}',
          label: '扩展字段1',
          preview: '{extend1}',
        },
        {
          id: '{扩展字段2}',
          label: '扩展字段2',
          preview: '{extend2}',
        },
        {
          id: '{扩展字段3}',
          label: '扩展字段3',
          preview: '{extend3}',
        },
      ],
      rules: {
        subject: [{ required: true, message: '请输入邮件主题', trigger: 'blur' }],
        emailId: [{ required: true, message: '请选择发件邮箱', trigger: 'blur' }],
      },
      form: {
        emailAddressExcel: '',
        emailAddress: this.emailAddress,
        content: '',
        date: '',
        time: '',
        isDateSend: false,
        subject: '',
        emailId: '',
      },
      value: '',
      tableData: [],
      userEmailList: [],
      lists: [],
      emailTemplateList: [],
      emailTemplateMap: {},
      dateOptionList: [
        {
          id: 'BeiJin',
          label: '北京时间',
        },
        {
          id: 'Pacific',
          label: '太平洋时间',
        },
        {
          id: 'MET',
          label: '中欧时间',
        },
        {
          id: 'Japan',
          label: '日本时间',
        },
        {
          id: 'GMT',
          label: '格林时间',
        },
        {
          id: 'Australian',
          label: '澳大利亚时间',
        },
      ],
    };
  },
  created() {
    this.getAllTemplateList();
    this.initData();
  },
  methods: {
    onExceed() {
      this.$gjMessage.warning('最多上传十个附件');
    },
    removeFile(file) {
      this.attachments = this.attachments.filter((item) => {
        return item.attId != file.attId;
      });
    },
    downloadFile(attId) {
      downloadAttFile(attId);
    },
    emailgHandleChange(val) {
      let index = this.emailTemplateMap[val].indexOf('<p>');
      if (index > -1) {
        this.form.content = this.emailTemplateMap[val];
      } else {
        this.form.content = this.emailTemplateMap[val]
          .split(/\n/)
          .map((line) => `<p>${line}</p>`)
          .join('\n');
      }
    },
    initData() {
      outEmailList().then((res) => {
        this.userEmailList = res.data;
      });
      getRemainingMail().then((res) => {
        this.remainingMail = res;
      });
      if (this.draftsId) {
        outTicketItemDraftsDetail(this.draftsId).then((res) => {
          this.form.draftsId = this.draftsId;
          this.form.subject = res.subject;
          this.form.content = res.content;
          this.form.templateId = res.templateId;
          this.form.emailId = res.emailId;

          this.attachments = Array.isArray(res.attachments)
            ? res.attachments.map((item) => {
                return {
                  attId: item.id,
                  fileId: item.id,
                  name: item.name,
                };
              })
            : [];
          this.emailAddressExcel =
            res.emailAddressExcel && res.emailAddressExcelName
              ? [
                  {
                    attId: res.emailAddressExcel,
                    fileId: res.emailAddressExcel,
                    name: res.emailAddressExcelName,
                  },
                ]
              : [];
          this.form.emailAddress = res.emailAddress;
          if (res.sendDateOriginal) {
            this.form.isDateSend = true;
            let arr = res.sendDateOriginal.split(' ');
            this.form.date = arr[0];
            this.form.time = arr[1];
            this.form.sendDateType = res.sendDateType;
          }
        });
      }
    },
    // 处理参数
    handelParmas() {
      let params = {
        draftsId: this.form.draftsId,
        subject: this.form.subject,
        content: this.form.content,
        templateId: this.form.templateId,
        emailId: this.form.emailId,
        attachments: this.attachments.map((item) => {
          return { id: item.attId, name: item.name };
        }),
      };
      if (this.form.isDateSend) {
        params.sendDateOriginal = `${this.form.date} ${this.form.time}:00`;
        params.sendDateType = this.form.sendDateType;
      }
      if (this.form.emailAddressExcel) {
        params.emailAddressExcel = this.form.emailAddressExcel;
        params.emailAddressExcelName = this.form.emailAddressExcelName;
      } else {
        params.emailAddress = this.form.emailAddress;
      }
      return params;
    },
    save() {
      if (this.loadingConfirm || this.loadingSave) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingSave = true;
          let params = this.handelParmas();
          (params.type = 'Drafts'),
            outTicketItemDraftSave(params)
              .then(() => {
                this.$emit('after');
                this.$gjMessage.success('保存成功');
              })
              .complete(() => {
                this.loadingSave = false;
              });
        } else {
          return false;
        }
      });
    },
    confirm() {
      if (this.loadingConfirm || this.loadingSave) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingConfirm = true;
          let params = this.handelParmas();
          if (this.form.isDateSend) {
            params.type = 'JobSend';
          } else {
            params.type = 'Send';
          }
          outTicketItemSend(params)
            .then(() => {
              this.$emit('after');
              this.$gjMessage.success('发送成功');
            })
            .complete(() => {
              this.loadingConfirm = false;
            });
        } else {
          return false;
        }
      });
    },
    importEnclosure() {
      // console.log(data)
      // this.attachments = data;
    },
    // 上传返现
    updateFileListEnclosure(data) {
      this.attachments = data;
    },
    checkUser() {
      this.$gjCreate(AppUserTable, {
        props: {
          tableData: this.tableData,
        },
      });
    },
    // 获取模板
    getAllTemplateList() {
      let parmas = {};
      getAllTemplateList(parmas).then((res) => {
        res.forEach((item) => {
          if (Array.isArray(item.marketMailTemplateVOList)) {
            item.marketMailTemplateVOList.forEach((k) => {
              this.emailTemplateMap[k.id] = k.content;
            });
          }
          item.name = item.templateType;
        });
        this.emailTemplateList = res;
      });
    },
    insertVariable(item) {
      this.$refs.gjWangEditor.insertVariable(item);
    },
    updateFileList(data) {
      this.form.emailAddressExcel = '';
    },
    // 解析excel
    importRelateProduct(a, uploadData, c, d, data) {
      this.form.emailAddressExcel = uploadData.id;
      this.form.emailAddressExcelName = uploadData.submittedFileName;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0]; //取第一张表，wb.SheetNames[0]是获取Sheets中第一个Sheet的名字
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容，wb.Sheets[Sheet名]获取第一个Sheet的数据
          const excellist = []; //清空接收数据
          //编辑数据
          for (var i = 0; i < ws.length; i++) {
            excellist.push({
              name: ws[i]['*买家姓名'],
              email: ws[i]['*买家邮箱'],
              ext1: ws[i].exec1,
              ext2: ws[i].exec2,
              ext3: ws[i].exec3,
            });
          }
          this.tableData = excellist;
        } catch (e) {
          this.$gjMessage.error('读取失败失败');
        }
      };
      fileReader.readAsBinaryString(data.file);
    },
  },
};
</script>


<style lang="scss">
.reply-off-site-mailbox-add-mail {
  .remaining-mail {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    font-size: 26px;
    margin: 12px 0;
    .color-1000{
      color: #ED6A0C;
    }
    .color-0{
      color: #F5222D;
    }
  }
  .to-buy {
    color: #1f6eef;
    cursor: pointer;
    padding-left: 30px;
    font-size: 12px;
  }
  .el-dialog__body {
    padding-bottom: 12px !important;
    .file-list {
      display: flex;

      flex-wrap: wrap;
      flex-direction: row;
      .file-item {
        margin-bottom: 5px;
        padding: 2px 6px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        margin-left: 10px;
        .file-name {
          max-width: 240px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-left: 2px;
        }
      }
      .el-icon-delete {
        opacity: 0;
      }
      .file-item:hover {
        background: #eef3fb !important;
        .el-icon-delete {
          opacity: 1 !important;
        }
      }
    }
  }
  .const-item-box {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    border: 1px solid #e4e5e6;
    border-bottom: 0px solid #e4e5e6;
    .title {
      height: 30px;
      line-height: 30px;
      background: #f6f7f8;
      box-sizing: border-box;
      padding-left: 20px;
      border-bottom: 1px solid #e4e5e6;
    }
  }
  .const-item {
    height: 37px;
    width: 100%;
    border-bottom: 1px solid #e4e5e6;
    box-sizing: border-box;
    padding-left: 20px;
    cursor: pointer;
    line-height: 37px;
  }
  .const-item:hover {
    color: rgba(31, 110, 239, 1);
  }
  .my-slelct-send {
    input {
      height: 32px;
    }
  }
  .email-addressExcel {
    position: relative;
    .special-upload {
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-left: 10px;
      padding: 2px 6px;
    }
    .file-name {
      max-width: 240px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 10px;
    }
    .el-icon-delete {
      opacity: 0;
    }
    .gj-upload-info:hover .el-icon-delete {
      opacity: 1 !important;
    }

    .template-download-loading {
      display: none;
    }
    .download-template--text {
      color: rgba(31, 110, 239, 1) !important;
      border: 0px solid #d8dadd !important;
    }
    .gj-upload-info-box {
      position: absolute;
      right: 10px;
      top: -7px;
    }
    .el-upload {
      .el-button {
        margin: 0 !important;
        background: #ffffff;
        color: rgba(51, 51, 51, 1);
        border: 1px solid #d8dadd;
      }
    }
  }
  .upload-btn span {
    white-space: nowrap;
  }
  .no-left-boeder {
    input {
      border-left: 0px solid;
    }
  }
  .el-dialog {
    width: 1450px !important;
  }

  .add-mail {
    .el-checkbox-my {
      margin-left: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    display: flex;
    .enclosure-upload {
      position: relative;
      .gj-upload-info-box {
        position: absolute;
        background: #ffffff;
        top: -60px;
        left: 16px;
        padding-left: 23px;
        display: none;
      }
    }
    .add-mail-left {
      flex: 4;

      padding-right: 15px;
      box-sizing: border-box;

      .footer-op {
        padding-left: 65px;
        margin-top: 15px;

        .left {
          float: left;
        }

        .right {
          float: right;
        }
      }
    }

    .add-mail-right {
      width: 246px;
      box-sizing: border-box;
      // border-left: 1px solid #e4e5e6;
      height: 510px;
      transform: translateY(-16px);
      padding: 12px 0 0 15px;
      .be-careful {
        color: black;
        background: #edf7ff;
        width: 230px;
        box-sizing: border-box;
        padding: 12px;
        color: rgba(102, 102, 102, 1);
        font-weight: 400;
        font-size: 12px;

        div {
          line-height: 24px;
        }
      }
    }
  }
}
</style>
